import { defineComponent as _defineComponent } from 'vue'
import { Client, ClientType, PaginatedResponse, Individual } from 'ah-api-gateways';
import { useSettingsStore } from '@/app/store/settingsModule';
import { useIndividualSettingsStore } from '@/app/store/individualSettingsModule';
import { computed, onBeforeMount, ref, watch } from 'vue';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { getServices } from '@/app/services';
import { countryNameFromCC } from 'ah-common-lib/src/helpers/countries';


export default /*#__PURE__*/_defineComponent({
  __name: 'ClientInformationView',
  props: { clientId: { type: String, required: false } },
  setup(__props) {

const props = __props;

const requestManager = useRequestManager().manager;

const services = getServices();

const settingsStore = useSettingsStore();

const individualSettingsStore = useIndividualSettingsStore();
/**
 * Potentially set client id to display information
 */


const client = ref<Client>();

const clientIndividuals = ref<PaginatedResponse<Individual> | null>(null);

onBeforeMount(() => settingsStore.loadEntityTypes());

const isCompany = computed(() => client.value!.type === ClientType.COMPANY);

function onClientChange() {
  clientIndividuals.value = null;
  if (props.clientId) {
    requestManager.cancel('getClientIndividuals');

    requestManager
      .sameOrCancelAndNew('getClient', services.client.getClient(props.clientId), props.clientId)
      .subscribe((response) => {
        client.value = response;
        requestManager
          .sameOrCancelAndNew(
            'getClientIndividuals',
            services.individual.listIndividuals({ clientId: response.id, pageSize: 1 }),
            response.id
          )
          .subscribe((response) => {
            clientIndividuals.value = response;
          });
      });
  } else {
    client.value = individualSettingsStore.client!;
  }
}

watch(() => props.clientId, onClientChange, { immediate: true });

const firstBlock = computed(() => {
  let out: { label: string; value?: string }[] = [];
  out.push({ label: 'Name of entity', value: client.value!.name });

  if (isCompany.value) {
    const company = client.value?.companyDetails;
    out.push({ label: 'Registration number', value: company?.registrationNumber });
    out.push({
      label: 'Country of incorporation',
      value: countryNameFromCC(company?.address.countryCode),
    });
    out.push({
      label: 'Entity type',
      value: settingsStore.entityTypesList.find((type) => type.id === company?.entityType)?.legalForm,
    });
  } else if (clientIndividuals.value?.list.length) {
    out.push({
      label: 'Country of residency',
      value: countryNameFromCC(clientIndividuals.value?.list[0].address.countryCode),
    });
  }
  return out;
});

const secondBlock = computed(() => {
  let out: { label: string; value?: string }[] = [];
  if (isCompany.value) {
    const individual = clientIndividuals.value?.list[0];
    return [
      { label: 'Address', value: client.value?.companyDetails.address?.addressLine },
      { label: 'Post code', value: client.value?.companyDetails.address?.postalCode },
      { label: 'Telephone number', value: individual?.phoneNumber },
      { label: 'Email', value: individual?.email },
    ];
  } else if (clientIndividuals.value?.list.length) {
    const individual = clientIndividuals.value.list[0];
    return [
      { label: 'Address', value: individual?.address?.addressLine },
      { label: 'Post code', value: individual?.address?.postalCode },
      { label: 'Telephone number', value: individual?.phoneNumber },
      { label: 'Email', value: individual?.email },
    ];
  }
  return out;
});

return { __sfc: true,requestManager, services, settingsStore, individualSettingsStore, props, client, clientIndividuals, isCompany, onClientChange, firstBlock, secondBlock }
}

})